<template>
	<h1>PROFILE</h1>
</template>

<script>
	export default {
		name: 'Profile',
	};
</script>
